import { getRootContextPath } from './context-path';

const keepAlivePollingIntervalMs = 1000 * 60 * 5;

export const keepAlive = () => {
  setInterval(async () => {
    await fetch(getRootContextPath() + '/keep-alive', { method: 'GET' });
  }, keepAlivePollingIntervalMs);
};
